import dayjs from 'dayjs'

import { Property } from '@collector/sportsapi-client-legacy'

export function formatDate(date: number | undefined): string {
  if (!date) {
    return '-- : -- : --'
  }

  return dayjs(Number(date) * 1000).format('HH:mm:ss')
}

export function getPropertyValue(
  properties: Property[] | undefined,
  propertyName: string,
): Property['value'] | undefined {
  const foundProperty = properties?.find(
    (property) => property.short_name === propertyName,
  )
  return foundProperty ? foundProperty.value : undefined
}

export function getCurrentXG(
  properties: Property[] | undefined,
): Property['value'] | undefined {
  const xgValue = getPropertyValue(properties, 'xG')
  if (!xgValue) {
    return undefined
  }

  return xgValue
}
